import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRequestSolutionRequestSent = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 241,
	height: 240,
	viewBox: "0 0 241 240",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 56.4746,
			y: 89.6035,
			width: 136.388,
			height: 79.4157,
			fill: "#3C59F6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77.1914 109.915C77.1914 108.81 78.0868 107.915 79.1914 107.915H80.7363C81.262 107.915 81.7665 108.122 82.1408 108.491L137.976 163.563C138.754 164.331 140.004 164.331 140.783 163.564L196.728 108.49C197.102 108.121 197.606 107.915 198.131 107.915H199.566C200.671 107.915 201.566 108.81 201.566 109.915V191.104C201.566 192.208 200.671 193.104 199.566 193.104H79.1914C78.0868 193.104 77.1914 192.208 77.1914 191.104V109.915Z",
			fill: "white",
			stroke: "#3C59F6",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M192.976 193.108H84.628C82.8777 193.108 81.9718 191.019 83.168 189.741L137.543 131.667C138.335 130.82 139.678 130.823 140.468 131.672L194.441 189.747C195.63 191.026 194.723 193.108 192.976 193.108Z",
			fill: "white",
			stroke: "#3C59F6",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M199.51 106.66H79.2506C77.4515 106.66 76.5672 108.85 77.862 110.1L138.214 168.322C138.991 169.072 140.223 169.07 140.997 168.317L200.904 110.094C202.191 108.843 201.305 106.66 199.51 106.66Z",
			fill: "white",
			stroke: "#3C59F6",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63.3544 77.512L60.2772 55.6485M52.0106 83.4091L37.345 64.7645M44.272 93.2978L22.988 84.9797",
			stroke: "#F385FF",
			strokeWidth: 3,
			strokeLinecap: "square"
		})
	]
});
export default SvgRequestSolutionRequestSent;
